import { useQuery } from "react-query";
import { axiosClient } from "../services/axiosInstance";

const useGetIncomeRange = () => {
  const data = useQuery(["getIncomeRange"], () =>
    axiosClient.post(`Setting/GepSettingList?groupSettingId=6`)
  );
  return data;
};
export default useGetIncomeRange;
